/**
 * 门户页统一数据加载：按模板类型 + 路由路径触发对应 API
 */
import { getMenuNodePath, normalizeContentPath } from '@/components/portal/common/utils/menuPath'
import { resolveLegalPageApiKey } from '@/components/layout/utils/footerLinkResolver'
import { isFocusCarouselRootPath } from '@/components/modules/news/utils/newsPages'
import {
  isProductCatalogPath,
  isProductsPath
} from '@/components/modules/products/utils/productHelpers'
import {
  isSolutionsSectionPath
} from '@/components/modules/solutions/utils/solutionNormalize'

function toLegalApiKey(path) {
  return String(path || '').trim().replace(/^\/+/, '')
}

/** 生成门户加载签名，用于侦听路由/栏目变化 */
export function getPortalLoadSignature(context, route, locale, store) {
  if (!context || context.notFound) return ''
  const rootId = context.rootMenu?.id ?? ''
  let signaturePath = normalizeContentPath(route?.path || '')

  if (context.contentVariant === 'legal' || context.contentVariant === 'privacy') {
    const apiKey = resolveLegalPageApiKey(context.contentVariant)
    if (apiKey) signaturePath = apiKey
  }

  return [
    locale || '',
    context.templateKey || '',
    rootId,
    context.contentVariant || '',
    signaturePath
  ].join('|')
}

/** 按当前门户上下文加载页面数据 */
export async function loadPortalPageData(store, context, route, options = {}) {
  const { force = false } = options
  if (!context || context.notFound) return

  const templateKey = context.templateKey
  const rootMenu = context.rootMenu
  const path = normalizeContentPath(route?.path || '')
  const locale = store.state.locale?.current
  if (!locale || !rootMenu || !templateKey) return

  switch (templateKey) {
    case 'FOCUS_CAROUSEL_LIST': {
      await store.dispatch('news/ensureNewsMeta', rootMenu)
      if (isFocusCarouselRootPath(path, rootMenu)) {
        await store.dispatch('news/reloadByPath', { path, rootMenu, force })
      }
      break
    }
    case 'INTRO_CARD_GRID': {
      await store.dispatch('about/fetchAbouts', { rootMenu, force })
      break
    }
    case 'CATEGORY_PRODUCT_ROW':
    case 'CATEGORY_PORTAL_CARDS': {
      const productsRootPath = getMenuNodePath(rootMenu)
      await store.dispatch('productCategories/fetchCategories')
      if (isProductsPath(path, productsRootPath) || isProductCatalogPath(path)) {
        await store.dispatch('products/reloadByPath', {
          path,
          productsRootPath,
          force
        })
      }
      break
    }
    case 'TAB_PANEL_SWITCH': {
      if (isSolutionsSectionPath(path, rootMenu)) {
        await store.dispatch('solutions/reloadByPath', { path, rootMenu, force })
      }
      break
    }
    case 'CONTENT_PAGE': {
      if (context.contentVariant === 'join') {
        const rootPath = getMenuNodePath(rootMenu)
        if (rootPath && path === rootPath) {
          await store.dispatch('join/reloadByPath', { path, rootMenu, force })
        }
      } else if (context.contentVariant === 'legal' || context.contentVariant === 'privacy') {
        const pagePath = resolveLegalPageApiKey(context.contentVariant)
        if (!pagePath) break
        await store.dispatch('legalPage/fetchLegalPage', {
          pagePath,
          force
        })
      }
      break
    }
    case 'CONTACT_FORM':
      // 联系页为静态表单，无 CMS 正文接口
      break
    default:
      break
  }
}

export { toLegalApiKey }
